import React from 'react';
import PropTypes from 'prop-types';

class ErrorBoundary extends React.Component {
    static propTypes = {
        children: PropTypes.element,
    }

    state = {
        hasError: false,
        error: null,
        info: null,
    }

    componentDidCatch(error, info) {
        this.setState({
            error,
            info,
            hasError: true,
        });
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div style={{
                    width: 600,
                    margin: "10px auto",
                }}>
                    <h1>Something went wrong.</h1>
                    <p>{this.state.error.message}</p>
                    <pre>{this.state.info.componentStack}</pre>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.js